import { getModifyBooleans } from 'services/helpers/campaignApiHelpers'

const { fetcher } = require('services/helpers/responseHandler')
const {
  normalizeCampaignEmailResponse
} = require('features/EmailEditor/campaignEmailCustomizationHelpers')

const getCustomCampaignList = async () =>
  fetcher.get('content/campaign/custom/list?kind=Custom')

const addCustomCampaign = async ({
  audienceId,
  deliveryStartDate,
  deliveryFinishDate,
  deliveryName
}) =>
  fetcher.post('content/campaign/custom/add', {
    item: {
      kind: 'Sales',
      audienceId,
      deliveryStartDate,
      deliveryFinishDate,
      deliveryName
    }
  })

const updateCustomCampaign = async details => {
  return fetcher.put('content/campaign/custom/modify', {
    details,
    ...getModifyBooleans(details)
  })
}

const getCustomCampaignStats = async id => fetcher.get('content/campaign/stats', { id })

const getList = async subsidiaryId =>
  fetcher.post(`content/notification/load`, { subsidiaryId })

const update = async ({ subsidiaryId, categories, details }) =>
  await fetcher.put(`content/notification/update`, {
    subsidiaryId,
    categories,
    details,
    ...getModifyBooleans(details)
  })

const updateOptedInPromo = async ({
  promotionCode,
  maxDiscountPercentage,
  promotionTagline,
  minNightsToStay
}) =>
  await fetcher.put('content/notification/update', {
    categories: ['CardAbandonmentOptedIn'],
    ...getModifyBooleans({
      promotionCode,
      maxDiscountPercentage,
      promotionTagline,
      minNightsToStay
    }),
    details: {
      promotionCode,
      maxDiscountPercentage,
      promotionTagline,
      minNightsToStay
    }
  })

const updateOTApromo = async ({
  promotionCode,
  maxDiscountPercentage,
  promotionTagline,
  minNightsToStay,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate
}) =>
  await fetcher.put('content/notification/update', {
    details: {
      promotionCode,
      maxDiscountPercentage,
      promotionTagline,
      minNightsToStay,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    },
    updateType: 'AllOtaPromo'
  })

const updateNonOTApromo = async ({
  promotionCode,
  maxDiscountPercentage,
  promotionTagline,
  minNightsToStay,
  promoValidityStartDate,
  promoValidityEndDate,
  hasPromoValidityDate
}) =>
  await fetcher.put('content/notification/update', {
    details: {
      promotionCode,
      maxDiscountPercentage,
      promotionTagline,
      minNightsToStay,
      promoValidityStartDate,
      promoValidityEndDate,
      hasPromoValidityDate
    },
    updateType: 'AllNonOtaPromo'
  })

const updateAllMediaURL = async ({ messageMediaUrls }) =>
  await fetcher.put('content/notification/update', {
    details: {
      messageMediaUrls
    },
    updateType: 'AllMediaUrl'
  })

const enableAllCampaigns = async () =>
  await fetcher.put('content/notification/update', {
    updateType: 'AllActive'
  })

const updateBulkMedium = async ({ medium, categories }) =>
  await fetcher.put('content/notification/update', {
    categories,
    details: { medium },
    isModifyMedium: true
  })

const updateAllMedium = async ({ medium, categories }) =>
  updateBulkMedium({ medium, categories })

const updateOtaMedium = async ({ medium, categories }) =>
  updateBulkMedium({ medium, categories })

const updateNonOtaMedium = async ({ medium, categories }) =>
  updateBulkMedium({ medium, categories })

const copy = async ({ originId, destinationId }) =>
  await fetcher.post(`content/notification/copy`, {
    fromSubsidiaryId: originId,
    toSubsidiaryId: destinationId
  })

const sendTestSms = async ({ contentCategory, contentId }) =>
  await fetcher.post(`content/campaign/test`, {
    contentCategory,
    contentId
  })

const sendTestSmsToAnotherNumber = async data =>
  await fetcher.post(`content/campaign/test`, data)

const sendTestEmail = async ({
  contentCategory = 'Custom',
  contentId,
  email,
  emailBodyHtml,
  emailSubject
}) =>
  await fetcher.post(`content/campaign/test`, {
    contentCategory,
    contentId,
    email,
    medium: 'Email',
    emailBodyHtml,
    emailSubject
  })

const spamCheck = async ({ category, proposedContent, proposedHasMedia }) =>
  await fetcher.post('content/spam/check/text', {
    category,
    proposedContent,
    proposedHasMedia
  })

const getCampaignResults = async ({ campaignId }) =>
  fetcher.get(`bookings/campaign?CampaignId=${campaignId}`)

const getAnnouncementResults = async ({ campaignId }) =>
  fetcher.get(`bookings/campaign?CampaignId=${campaignId}`)

// {
//   return new Promise((resolve, reject) => {
//     setTimeout(() => {
//       resolve({
//         deliveriesTotal: 4358,
//         deliveriesSent: 4356,
//         clicksTotal: 111,
//         bookingsTotal: 100,
//         bookingsTotalRate: 17675.76,
//         campaignBookingViews: [
//           {
//             subsidiaryId: '08d70c6e-a338-7b41-f362-8ca7ac7799dc',
//             bookingId: 11077951,
//             subscriberId: 5593372,
//             textedOn: '2022-01-16T22:16:29',
//             bookingDate: '2022-03-15T00:00:00',
//             confirmationCode: '2840140',
//             rateCode: 'IGCOR',
//             totalRate: 70,
//             checkIn: '2022-03-15T00:00:00',
//             checkOut: '2022-03-16T00:00:00',
//             previousCheckOut: '2021-12-24T00:00:00',
//             daysWithoutBookingUntilInvite: 23,
//             lastStayDate: '2021-12-24T00:00:00',
//             distanceToHotel: 957.69,
//             subscriptionId: 5593372,
//             firstName: 'Jose',
//             lastName: 'Hernandez',
//             fullName: 'Jose Hernandez',
//             trackingCode: 'Rack,IGCOR',
//             deliveryName: null,
//             text: 'Jose, We have an amazing brunch event happening at Holiday Inn & Suites Orlando SW - Celebration Area on February 20th. Use this link to book your tickets now!\n\nhttps://goldensmackdown.eventbrite.com\nText STOP for NO text\nsavibook.com/holidayinn/Kissimmee/My6l',
//             mediaUrl: 'c/20220108163937__swaypay__IMG_8241 (1).jpeg',
//             cancellationDate: null,
//             guestCount: 1,
//             roomNumber: '2612',
//             bookingSource: 'WI.',
//             nightlyRate: 70,
//             clickCount: 0,
//             callCount: 0,
//             messageCount: 1,
//             priorAgencyName: null,
//             priorBookingId: null,
//             bookingDaysAfterText: 58,
//             bookDaysBeforeCheckIn: 0,
//             numberOfBookingsLast12Month: 1,
//             bookedDaysAfterLastBooking: 23,
//             bookingProvider: 'Unknown',
//             bookingStatus: 'Completed',
//             searchString: 'Jose Hernandez IGCOR 2840140'
//           },
//           {
//             subsidiaryId: '08d70c6e-a338-7b41-f362-8ca7ac7799dc',
//             bookingId: 10641620,
//             subscriberId: 5452506,
//             textedOn: '2022-01-16T22:18:33',
//             bookingDate: '2022-02-17T00:00:00',
//             confirmationCode: '2781776',
//             rateCode: 'IDU25',
//             totalRate: 110.49,
//             checkIn: '2022-02-18T00:00:00',
//             checkOut: '2022-02-19T00:00:00',
//             previousCheckOut: '2021-12-22T00:00:00',
//             daysWithoutBookingUntilInvite: 25,
//             lastStayDate: '2021-12-22T00:00:00',
//             distanceToHotel: 207.71,
//             subscriptionId: 5452506,
//             firstName: 'Jose',
//             lastName: 'Diaz',
//             fullName: 'Jose Diaz',
//             trackingCode: 'Internet - OTA,IDU25',
//             deliveryName: null,
//             text: 'Jose, We have an amazing brunch event happening at Holiday Inn & Suites Orlando SW - Celebration Area on February 20th. Use this link to book your tickets now!\n\nhttps://goldensmackdown.eventbrite.com\nText STOP for NO text\nsavibook.com/holidayinn/Kissimmee/MyIr',
//             mediaUrl: 'c/20220108163937__swaypay__IMG_8241 (1).jpeg',
//             cancellationDate: null,
//             guestCount: 2,
//             roomNumber: '2826',
//             bookingSource: 'CRS.IDCDS',
//             nightlyRate: 110.49,
//             clickCount: 0,
//             callCount: 0,
//             messageCount: 0,
//             priorAgencyName: null,
//             priorBookingId: null,
//             bookingDaysAfterText: 33,
//             bookDaysBeforeCheckIn: 1,
//             numberOfBookingsLast12Month: 2,
//             bookedDaysAfterLastBooking: 25,
//             bookingProvider: 'Unknown',
//             bookingStatus: 'Completed',
//             searchString: 'Jose Diaz IDU25 2781776'
//           },
//           {
//             subsidiaryId: '08d70c6e-a338-7b41-f362-8ca7ac7799dc',
//             bookingId: 10286282,
//             subscriberId: null,
//             textedOn: '2022-01-16T22:20:21',
//             bookingDate: '2022-01-26T00:00:00',
//             confirmationCode: '2726012',
//             rateCode: 'IBGP1',
//             totalRate: 65,
//             checkIn: '2022-01-29T00:00:00',
//             checkOut: '2022-01-30T00:00:00',
//             previousCheckOut: '2021-12-19T00:00:00',
//             daysWithoutBookingUntilInvite: 28,
//             lastStayDate: '2021-12-19T00:00:00',
//             distanceToHotel: 0,
//             subscriptionId: 0,
//             firstName: 'Edward',
//             lastName: 'Davis',
//             fullName: 'Edward Davis',
//             trackingCode: 'Corporate Group - C,IBGP1',
//             deliveryName: null,
//             text: 'Edward, We have an amazing brunch event happening at Holiday Inn & Suites Orlando SW - Celebration Area on February 20th. Use this link to book your tickets now!\n\nhttps://goldensmackdown.eventbrite.com\nText STOP for NO text\nsavibook.com/holidayinn/Kissimmee/Myjt',
//             mediaUrl: 'c/20220108163937__swaypay__IMG_8241 (1).jpeg',
//             cancellationDate: null,
//             guestCount: 2,
//             roomNumber: '1609',
//             bookingSource: 'G-CORP.',
//             nightlyRate: 65,
//             clickCount: 0,
//             callCount: 0,
//             messageCount: 0,
//             priorAgencyName: null,
//             priorBookingId: null,
//             bookingDaysAfterText: 13,
//             bookDaysBeforeCheckIn: 3,
//             numberOfBookingsLast12Month: 0,
//             bookedDaysAfterLastBooking: 28,
//             bookingProvider: 'Unknown',
//             bookingStatus: 'Completed',
//             searchString: 'Edward Davis IBGP1 2726012'
//           }
//         ]
//       })
//     })
//   })
// }

const getCampaignHistory = async ({ contentId, isDefaultCampaigns = false }) =>
  fetcher.get(`content/notification/load/changes`, {
    contentId,
    isDefault: isDefaultCampaigns
  })

const updateAlternateReviewLink = async ({ alternateReviewLink }) =>
  await fetcher.post('merchants/update/subsidiary/byExternal', { alternateReviewLink })

const compareDefault = async ({ category }) =>
  fetcher.get(`content/campaign/compare`, { category })

const publishCampaign = async ({ subsidiaryIds, newContent, category }) =>
  fetcher.post(`content/campaign/publish`, { subsidiaryIds, newContent, category })

const postCampaignEstimationScreenshot = async ({ contentId, screenshot }) => {
  fetcher.post(`content/campaign/custom/screenshot`, { contentId, screenshot })
}

const getCampaignCredit = async () => fetcher.get('content/campaign/custom/credit')

const addCampaignCredit = async ({ credit }) =>
  fetcher.put('content/campaign/custom/credit', { Credit: credit })

const getCampaignEmail = async ({ campaignId }) =>
  normalizeCampaignEmailResponse(await fetcher.get(`content/email/${campaignId}`))

const updateCampaignEmail = async ({ campaignId, emailParams, html, globalParams }) =>
  fetcher.put(`content/email/`, { campaignId, emailParams, html, globalParams })

const campaignApi = {
  getList,
  update,
  copy,
  getCustomCampaignList,
  addCustomCampaign,
  updateCustomCampaign,
  sendTestSms,
  spamCheck,
  getCustomCampaignStats,
  updateNonOTApromo,
  updateOTApromo,
  updateOptedInPromo,
  updateAllMediaURL,
  enableAllCampaigns,
  updateAllMedium,
  updateOtaMedium,
  updateNonOtaMedium,
  getCampaignResults,
  getCampaignHistory,
  updateAlternateReviewLink,
  compareDefault,
  publishCampaign,
  postCampaignEstimationScreenshot,
  getAnnouncementResults,
  getCampaignCredit,
  addCampaignCredit,
  sendTestSmsToAnotherNumber,
  getCampaignEmail,
  updateCampaignEmail,
  sendTestEmail
}

export default campaignApi
